import React from 'react';
import MeterHero from './gridxpage/MeterHero';
import HowItWorks from './gridxpage/HowItWorks';
import CoreFunctionality from './gridxpage/CoreFunctionality';
import '../styles/GRIDxPage.css';

const GRIDxPage = () => {
  return (
    <div className="gridx-page-full">
      <MeterHero />
      <HowItWorks />
      <CoreFunctionality />

      <div className="gridx-page__cta-section">
        <h2 className="gridx-page__cta-title">Ready to transform your energy management?</h2>
        <p className="gridx-page__cta-text">
          Contact us today to learn how GRIDx can benefit your community or business.
        </p>
        <a href="/contact" className="gridx-page__cta-button">
          Get in Touch
        </a>
      </div>
    </div>
  );
};

export default GRIDxPage;
